import { StampAnnotation } from '@st/sdk'
import { CheckmarkToolState } from '~/st-doc-viewer/annotations'
import { CHECKMARK_TICK_STAMP } from '../stamp/templates'

export function syncToolStateWithAnnotation(annotation: StampAnnotation): CheckmarkToolState {
  return {
    name: 'checkmark',
    settings: {
      templateId: CHECKMARK_TICK_STAMP.id,
      color: annotation.color,
      stampSize: annotation.stampSize
    }
  }
}
